import {
  FacebookOutlined,
  Instagram,
  LinkedIn,
  QrCode2,
  Twitter,
} from "@mui/icons-material";
import {
  Box,
  Grid,
  IconButton,
  Typography,
  Container,
  Divider,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { ThemeDetails } from "../../theme/ThemeDetails";

import logoTicoTicket from "../../assets/images/logoticoticket.png";

export const PublicFooter = () => {
  return (
    <Box
      component={"footer"}
      sx={{ bgcolor: "#1C1625", color: "white", pt: 7 }}
    >
      <Container>
        <Grid container alignItems="center" pb={3} spacing={2}>
          <Grid item xs={12} md={2}>
            <Box
              component={RouterLink}
              to={`/`}
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start",
                textDecoration: "none",
              }}
            >
              <img
                src={logoTicoTicket}
                alt="TicoTicket Logo"
                style={{
                  height: "20px",
                  width: "auto",
                }}
              />
            </Box>
          </Grid>

          <Grid item xs={12} md={6} container justifyContent={{xs:"flex-start", md:"space-around"}}>
            <Grid
              item
              xs={10}
              sm={3}
              sx={{
                alignItems: "flex-start",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <List
                dense
                sx={{
                  width: "100%", // Para asegurarte de que el ancho sea completo
                  "& a": { color: "white", textDecoration: "none" },
                  "& a:hover": { color: "secondary.main" },
                  fontFamily: "Goldman",
                }}
                subheader={
                  <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                    Menú
                  </Typography>
                }
              >
                <ListItem component={RouterLink} to="/">
                  <ListItemText
                    primary="Inicio"
                    sx={{
                      "&:hover": {
                        color: "secondary.dark",
                      },
                    }}
                  />
                </ListItem>
                <ListItem component={RouterLink} to="/about-us">
                  <ListItemText
                    primary="Sobre Nosotros"
                    sx={{
                      "&:hover": {
                        color: "secondary.dark",
                      },
                    }}
                  />
                </ListItem>
                <ListItem component={RouterLink} to="/faq">
                  <ListItemText
                    primary="Preguntas frecuentes"
                    sx={{
                      "&:hover": {
                        color: "secondary.dark",
                      },
                    }}
                  />
                </ListItem>
              </List>
            </Grid>

            <Grid item xs={12} sm={6}>
              <List
                dense
                sx={{
                  "&:hover": {
                    color: "secondary.dark",
                  },
                }}
                subheader={
                  <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                    Contacto
                  </Typography>
                }
              >
                <ListItem>
                  <ListItemText
                    typeof="email"
                    primary="jgonzalez@fuegocreativo.com"
                  />
                </ListItem>
                <ListItem>
                  <ListItemText primary="hvargas@sincorbata.com" />
                </ListItem>
              </List>
            </Grid>
          </Grid>

          <Grid item xs={12} md={4}>
            <Box display="flex" flexDirection="column" alignItems="flex-end">
              <Typography
                variant="h6"
                pl={0}
                textAlign="right"
                gutterBottom
                sx={{ fontWeight: "bold" }}
              >
                Siente el ritmo de la vida, cada ticket una nueva historia
              </Typography>

              <Box display="flex" color={"secondary.main"}>
                <IconButton aria-label="facebook" color="primary">
                  <FacebookOutlined />
                </IconButton>

                <IconButton aria-label="instagram" color="primary">
                  <Instagram />
                </IconButton>
                <IconButton aria-label="linkedin" color="primary">
                  <LinkedIn />
                </IconButton>
              </Box>
            </Box>
          </Grid>
        </Grid>

        <Divider
          sx={{ borderBottomWidth: "thin", opacity: 0.2, bgcolor: "white" }}
        />
        <Box textAlign="center" pt={1.5} pb={2.5}>
          <Typography variant="body1">
            © Copyright 2024. TicoTicket by SpaceToast. All rights reserved
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};
